

export default {
    logging: false,
    baseURL: '/api',
    version: 'v1.0.40',//v1.0.30
    timerAlertCountdown: '120',
    Crypto: {
        ECDH: {
            PublicKeyB:
                'BAD1Fc9PG29SdYLnwP1qb3Tl8J+NAB2+XcofH3sUKqL/amZ7c1mXZINJkVJY+ifm93N+FV9N/mPmzTUacOXlXvn1NgHYRq3s00mrD6mNToJOM5MXSDdHdSwFeoIsOfA7FGU1ICce1lYQ4MeHoCiv0TJHm4iCYVLahOe8jXtrm+5NAaFfqQ=='
        }
    },
    fileUrl:"/api/file/",
    publicFileUrl:"api/file/public/",
    feedPortalUrl:"https://md1s2.lc.utrade.com.my",
    headerLogo:"/img/FiNext/traderstation-logo.png",
    utradeWebUrl:"https://www.utrade.com.my",
    mfaUserGuideUrl:"/assets/UOBKH-MFA-User-Guide-v1_20251205.pdf"
};
